import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { WorkshopModel } from '../../models/workshop.model';
import { InformWayModel } from '../../../../shared/models/inform-way.model';
import { WorkshopService } from '../../services/workshop.service';
import { BasicInformationService } from '../../../../shared/services/basic-information.service';
import { PersianTitlesService } from '../../../../core/services/persian-titles.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { NavigationService } from 'src/app/shared/services/navigation.service';

@Component({
  selector: 'app-workshop-register',
  templateUrl: './workshop-register.component.html',
  styleUrls: ['./workshop-register.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WorkshopRegisterComponent implements OnInit, OnDestroy {
  workshopId: number;
  @Output() onHideWorkshopRegisteringPopup = new EventEmitter<boolean>();

  workshop: WorkshopModel;
  isPreRegister = false;
  subscription: Subscription;
  informWaySubscription: Subscription;

  form: FormGroup;

  informWays: InformWayModel[];

  showPopup: boolean = false;
  loading: boolean = false;
  defaultBackRoute: string = '/workshops';

  // Labels
  titleLabel: string;
  attendanceTypeLabel: string;
  informWayLabel: string;
  registerLabel: string;
  registerPromptLabel: string;
  questionsLabel: string;

  get popUpWith() {
    return window.innerWidth > 768 ? '700px' : '90%';
  }
  constructor(
    private workshopService: WorkshopService,
    private basicInformationService: BasicInformationService,
    private persianTitlesService: PersianTitlesService,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private navigationService: NavigationService,
  ) {}

  ngOnInit() {
    this.workshopId = this.route.snapshot.params['id'];
    this.isPreRegister = this.route.snapshot.data['isPreRegister'];

    this.initLabels();
    this.fetchWorkshop(this.workshopId);
    this.initForm();
  }

  onHide() {
    this.showPopup = false;
    this.onHideWorkshopRegisteringPopup.emit(true);
  }

  /** Open URL in a new tab (reliable when target="_blank" is ignored by the host context). */
  openInNewTab(url: string, event?: Event) {
    if (event) {
      event.preventDefault();
    }
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

  onRegister() {
    if (this.form.valid) {
      this.loading = true;
      this.subscription = this.workshopService
        .registerOnWorkshop(this.workshop.id, this.form.value)
        .subscribe(
          () => {
            this.messageService.add({
              severity: 'success',
              summary:
                this.persianTitlesService.Phrases
                  .WorkshopRegistrationRegisteredAndApprovedSuccessfully,
            });
            this.loading = false;
            this.navigationService.back(this.defaultBackRoute);
          },
          (error) => {
            if (error.error) {
              this.messageService.add({
                severity: 'danger',
                summary: error.error.detail,
              });
            } else {
              this.messageService.add({
                severity: 'danger',
                summary:
                  this.persianTitlesService.Phrases.WorkshopRegisterError,
              });
            }
            this.loading = false;
          },
        );
    } else {
      this.messageService.add({
        severity: 'danger',
        summary: this.persianTitlesService.Phrases.FormValueError,
      });
    }
  }

  ngOnDestroy() {
    this.informWaySubscription?.unsubscribe();
    this.subscription?.unsubscribe();
  }

  private fetchWorkshop(workshopId) {
    this.informWaySubscription = this.basicInformationService
      .getInformWays()
      .subscribe((data) => {
        this.informWays = data;
      });
    this.subscription = this.workshopService
      .getWorkshop(workshopId)
      .subscribe((workshop) => {
        this.workshop = workshop;
        this.form.patchValue({
          workshopId: this.workshop.id,
        });
        this.showPopup = true;
      });
  }

  private initForm() {
    this.form = new FormGroup({
      attendanceTypeId: new FormControl(null, Validators.required),
      informWayId: new FormControl(null, Validators.required),
      confirmed: new FormControl(false, Validators.requiredTrue),
      workshopId: new FormControl(null, Validators.required),
      questions: new FormControl(null),
      motivation_letter: new FormControl(null),
    });
  }

  private initLabels() {
    this.titleLabel = this.persianTitlesService.Items.Register;
    this.attendanceTypeLabel = this.persianTitlesService.Items.AttendanceType;
    this.informWayLabel = this.persianTitlesService.Items.InformWay;
    this.questionsLabel = this.persianTitlesService.Phrases.EnterYourQuestions;
    this.registerLabel = this.persianTitlesService.Items.Register;
    this.registerPromptLabel = this.persianTitlesService.Phrases.RegisterPrompt;
  }
}
